/**
 * Get slate class name: slate-<type>
 */
export const getSlateClass = (type: string) => `slate-${type}`;
